._root_7wiah_1 {
  display: flex;
  gap: 4px;
  align-items: center; }
  ._root_7wiah_1 > * {
    vertical-align: bottom; }
